export const PlatformCodes = {
  PIRO_CP: "PIRO_CP",
  PIRO_WEBPOS: "PIRO_WEBPOS",
  PIRO_SPIFF: "PIRO_SPIFF"
}


